/* eslint-disable no-unused-expressions */

export function transformDataForReviewScreen(nestedFieldSelectorData = {}) {
  const result = {};

  const initialConfig = [
    {
      columnId: 1,
      displayOrder: 1,
      isDefault: true,
      jsonKey: 'ledger',
      label: 'Ledger',
      type: 'string',
    },
    {
      columnId: 2,
      displayOrder: 2,
      isDefault: true,
      jsonKey: 'debit',
      label: `Debit (${nestedFieldSelectorData.currencyCode})`,
      type: 'string',
    },
    {
      columnId: 3,
      displayOrder: 3,
      isDefault: true,
      jsonKey: 'credit',
      label: `Credit (${nestedFieldSelectorData.currencyCode})`,
      type: 'string',
    },
    {
      columnId: 4,
      displayOrder: 4,
      isDefault: true,
      jsonKey: 'internalNote',
      label: 'Internal Note',
      type: 'string',
    },
  ];

  result.config = initialConfig;
  result.data = formatDataFromNestedField(nestedFieldSelectorData);
  return result;
}

function formatDataFromNestedField(rawData) {
  let viewId = localStorage.getItem('newIndex');
  let responseData = [];
  let dataList = [];
  let updatedFieldList = rawData.list !== undefined ? rawData.list.filter((listItem) => listItem.lockedBy !== -1) : [];

  // sort by id
  updatedFieldList &&
    updatedFieldList.sort((a, b) => {
      return a.lockedBy - b.lockedBy;
    });

  updatedFieldList &&
    updatedFieldList.forEach((row) => {
      const elementValues = {};

      rawData.inputList.forEach((eachList) => {
        elementValues[`${eachList.id}`] = rawData[`InputValue_${eachList.id}_${row.lockedBy}`];
      });

      responseData = responseData.concat({
        name: rawData[`DropDownValue_${row.lockedBy}`],
        ...elementValues,
      });
    });

  for (let index = 0; rawData.list && index <= viewId; index++) {
    if (rawData.softDeleted.indexOf(index) === -1) {
      dataList = dataList.concat({
        name: rawData[`DropDownValue_${index}`],
        v1: rawData[`InputValue_v1_${index}`],
        v2: rawData[`InputValue_v2_${index}`],
        v3: rawData[`InputValue_v3_${index}`],
      });
    }
  }
  return dataList && dataList.length < responseData.length ? responseData : dataList;
}

export function computeBalanceFromInputField(nestedFieldSelectorData = {}) {
  const formattedData = formatDataFromNestedField(nestedFieldSelectorData);
  let displayAmountFlag = false;
  if (formattedData.length > 0) {
    displayAmountFlag = !!(formattedData[0].v1 !== undefined || formattedData[0].v2 !== undefined);
  }

  let fromValues = 0;
  let toValues = 0;

  formattedData.forEach((dataList) => {
    if (dataList.v1 !== undefined && dataList.v1 !== '') {
      fromValues += parseFloat(dataList.v1);
    } else if (dataList.v2 !== undefined && dataList.v2 !== '') {
      toValues += parseFloat(dataList.v2);
    }
  });

  displayAmountFlag = fromValues + toValues !== 0;
  const balanceValue = fromValues - toValues < 0 ? (fromValues - toValues) * -1 : fromValues - toValues;
  return displayAmountFlag ? balanceValue.toFixed(2) : -1;
}

export default {
  transformDataForReviewScreen,
  computeBalanceFromInputField,
};
